import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { TaskTimer } from '../../data-services/task-timer/task-timer.model';

export const getTaskTimer = createAction('[TaskTimer/API] GET TaskTimer');

export const putTaskTimer = createAction(
    '[TaskTimer/API] PUT TaskTimer',
    props<{ JsonString: any }>()
);

export const putTaskTimerHistory = createAction(
    '[TaskTimer/API] PUT TaskTimerHistory',
    props<{ JsonString: any; StartDate?: string; EndDate?: string }>()
);

export const loadTaskTimers = createAction(
    '[TaskTimer/API] Load TaskTimers',
    props<{ taskTimers: any[] }>()
);

export const addTaskTimer = createAction(
    '[TaskTimer/API] Add TaskTimer',
    props<{ taskTimer: TaskTimer }>()
);

export const upsertTaskTimer = createAction(
    '[TaskTimer/API] Upsert TaskTimer',
    props<{ taskTimer: TaskTimer }>()
);

export const addTaskTimers = createAction(
    '[TaskTimer/API] Add TaskTimers',
    props<{ taskTimers: TaskTimer[] }>()
);

export const upsertTaskTimers = createAction(
    '[TaskTimer/API] Upsert TaskTimers',
    props<{ taskTimers: TaskTimer[] }>()
);

export const updateTaskTimer = createAction(
    '[TaskTimer/API] Update TaskTimer',
    props<{ taskTimer: Update<TaskTimer> }>()
);

export const updateTaskTimers = createAction(
    '[TaskTimer/API] Update TaskTimers',
    props<{ taskTimers: Update<TaskTimer>[] }>()
);

export const deleteTaskTimer = createAction(
    '[TaskTimer/API] Delete TaskTimer',
    props<{ id: string }>()
);

export const deleteTaskTimers = createAction(
    '[TaskTimer/API] Delete TaskTimers',
    props<{ ids: string[] }>()
);

export const clearTaskTimers = createAction('[TaskTimer/API] Clear TaskTimers');
